import React, {FocusEventHandler} from 'react'
import Link from "@Generic/navigation/Link";
import SourcedImage from "@Images/components/SourcedImage";

interface AppStoreLinkProps {
    link?: string,
    filePath: string,
    fileType: "jpg" | "jpeg" | "png" | "svg",
    className?: string,
    handleOnClick?: FocusEventHandler<HTMLInputElement>,
}

const AppStoreLink = ({link, filePath, fileType, className, handleOnClick}: AppStoreLinkProps) => (
    <Link
        className={className}
        href={link}
        onClick={handleOnClick}
    >
        <SourcedImage
            filePath={filePath}
            fileType={fileType}
        />
    </Link>
)

export default AppStoreLink